import { Check } from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";

const points = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Boost admissions by up to ₹2.5 crores" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "24×7 automated workforce running your entire school" },
];

const data = [{
    title: "₹5 lakh",
    description: "AI services free (Year 1)",
}, {
    title: "1%",
    description: "Schools per state can join",
}, {
    title: "10 Mins",
    description: "Full setup",
}, {
    title: "₹25 Lakh",
    description: "Save yearly in losees",
}];


export default function KeyHighlights() {

    return (
        <Box
            badge={"Why Schools Choose AI For Startups"}
            title={"Key Highlights for New School Startups"}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    <div className="grid grid-cols-4 md:grid-cols-1 gap-6">
                        {data.map((member, index) => <MarktingCard key={"memberasdsadInnerCard" + index} member={member} />)}
                    </div>
                </div>
            }
            rightBlock={points.map((section, index) => (<div key={"KeyHighlightsPoints" + index} className="bg-[white] p-4 border border-[#E2E8F1] flex items-center gap-2 rounded-xl">
                {section?.icon}
                <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
            </div>
            ))}
        />
    );
}